// Second-image hybrid for product cards.
//
// The card's 2nd image is shown two ways:
//  - Desktop: as a hover cross-fade overlay on slide 0 (`.card-gallery__hover-media`), so
//    its own carousel slide would be a duplicate → it is dropped from the carousel.
//  - Mobile: there is no hover, so it must stay a normal swipeable slide.
//
// Liquid renders one HTML for all viewports, so we toggle the slide's `hidden` attribute by
// viewport here. The slideshow already excludes `hidden` slides from navigation.
const mql = matchMedia('(min-width: 768px)');

function sync() {
  const isDesktop = mql.matches;
  for (const slide of document.querySelectorAll('.card-gallery__hover-slide')) {
    if (isDesktop) {
      slide.setAttribute('hidden', '');
    } else {
      slide.removeAttribute('hidden');
    }
  }
}

// Coalesce bursts of DOM mutations (filtering, infinite scroll).
let scheduled = false;
function schedule() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    sync();
  });
}

sync();
mql.addEventListener('change', sync);

// A deferred section's cards are parked in a <template> while this module first runs, so the
// sync() above cannot see them: `product-selection` is the section that matters here, and its
// 2nd-image slides stayed in the carousel, so the next arrow showed the image the hover had
// just shown instead of the third. The section announces its own hand-over, so listening is
// enough - no observer, and it covers every deferred section rather than that one.
document.addEventListener('deferred-section:revealed', schedule);

// Where cards appear by mutating the DOM, that is <results-list> (filtering, infinite scroll),
// so the observer is scoped there instead of to the whole document. Galleries in other, static
// contexts (related products, etc.) are already covered by the initial sync() above, and the
// Algolia hits, which mutate no list of ours, by the `refresh` exposed at the end of this file.
const observer = new MutationObserver(schedule);
for (const list of document.querySelectorAll('results-list')) {
  observer.observe(list, { childList: true, subtree: true });
}

// Algolia hits arrive as strings written with innerHTML, so the module tag the card carries never
// executes there and no mutation of a `results-list` announces them either. `algolia-liquid-card.js`
// calls this once it has put a card on the page. It is `schedule`, not `sync`, so a whole grid of
// hits settling at once still costs a single pass.
window.CardHoverSlide = { refresh: schedule };
